module.exports = __webpack_public_path__ + "img/ess_platinum.cac3329c.png";